import React, { useState, useEffect } from 'react';
import './Sidebar.scss';
import { Link, useLocation } from 'react-router-dom';
import { IoIosArrowDown } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import Cookies from "js-cookie";
import { logoutAdmin } from "../redux/services/authService/authApi";
import { errorToast, successToast } from "../Utils/toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  MdDashboard,
  MdPeople,
  MdBusinessCenter,
  MdInventory,
  MdCategory,
  MdTask,
  MdQuestionAnswer,
  MdNotificationsActive,
  MdGroups,
  MdCalendarMonth,
  MdEvent,
  MdSettings,
  MdLogout,
  MdChat,
  MdAssignment,
  MdCorporateFare,
  MdBrandingWatermark,
  MdStraighten,
  MdCheckCircle,
  MdTranscribe
} from "react-icons/md";

import logo from '../assets/image/logo-light.png';
const Sidebar = ({ isOpen, onToggleSidebar }) => {
  const location = useLocation();
  // const [permissions, setPermissions] = useState({});
  // const [role, setRole] = useState("");
  // const [loading, setLoading] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { permissions, role: _rawRole } = useSelector((state) => state.auth);
  const role = typeof _rawRole === "string" ? _rawRole.toLowerCase() : "";
  const [activeMenu, setActiveMenu] = useState(() => {
    return localStorage.getItem("activeMenu") || "";
  });
  // useEffect(() => {
  //   const fetchPermissions = async () => {
  //     try {
  //       const token = Cookies.get("adminToken");
  //       const staffData = localStorage.getItem("admin");
  //       const staffId = staffData ? JSON.parse(staffData).id : null;
  //       console.log("fdcsdfsf", staffId)
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_BASE_URL}/admin/staff-permissions`,
  //         {
  //           method: "POST",
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ id: staffId }),
  //         }
  //       );

  //       const result = await response.json();

  //       console.log("result", result)

  //       if (result.success) {
  //         setRole(result.data.role);
  //         setPermissions(result.data.staff_permission || {});

  //       }
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchPermissions();
  // }, []);

  const navigate = useNavigate();

  // const menuItems = [
  //   {
  //     items: [
  //       {
  //         id: 'dashboard',
  //         title: 'Dashboard',
  //         href: '/',
  //         icon: <MdDashboard />,
  //       },



  //       {
  //         id: 'Lead Management',
  //         title: 'Lead Management',
  //         permissionKey: "lead",
  //         dropdown: true,
  //         icon: <MdBusinessCenter />,
  //         children: [
  //           {
  //             id: 'lead',
  //             title: 'Lead List',
  //             href: '/lead-list',
  //           },
  //           {
  //             id: 'LeadAssigned',
  //             title: 'Lead Assigned',
  //             href: '/lead-staff-list',
  //           },


  //         ],
  //       },

  //       {
  //         id: 'inventoryManagement',
  //         title: 'Inventory Management',
  //         dropdown: true,
  //         icon: <MdPeople />,
  //         children: [
  //           {
  //             id: 'category',
  //             title: 'Category Management',
  //             href: '/categories-list',
  //             icon: <MdCategory />,
  //           },

  //         ],
  //       },

  //       {
  //         id: 'staff-management',
  //         title: 'Staff Management',
  //         dropdown: true,
  //         icon: <MdPeople />,
  //         children: [
  //           {
  //             id: 'staff',
  //             title: 'Staff',
  //             href: '/staff-list  ',
  //           },
  //           {
  //             id: 'role',
  //             title: 'Role',
  //             href: '/role-list  ',
  //           },
  //           {
  //             id: 'StaffActivity',
  //             title: 'Staff Activity',
  //             href: '/Staff-activity',
  //             icon: <MdCheckCircle />,
  //           },
  //         ],
  //       },



  //       {
  //         id: 'task',
  //         title: 'Task',
  //         href: '/task',
  //         icon: <MdLocationCity />,
  //       },

  //       {
  //         id: "chat",
  //         title: "Chat",
  //         href: "/chat",
  //         icon: <FiClipboard />,
  //         permissionKey: "chat",
  //       },

  //       {
  //         id: 'faq',
  //         title: 'FAQ',
  //         href: '/faq',
  //         icon: <MdReport />,
  //       },

  //       {
  //         id: '/reminder',
  //         title: 'Reminder',
  //         href: '/reminder',
  //         icon: <MdCheckCircle />,
  //       },
  //       {
  //         id: 'meeting',
  //         title: 'Meeting',
  //         href: '/meeting',
  //         icon: <MdCheckCircle />,
  //       },
  //       {
  //         id: 'leave',
  //         title: 'Leave',
  //         href: '/leave',
  //         icon: <MdCheckCircle />,
  //       },
  //       {
  //         id: 'calendar',
  //         title: 'Calendar',
  //         href: '/calendar',
  //         icon: <MdCheckCircle />,
  //       },

  //       {
  //         id: 'content-setting',
  //         title: 'Content / Setting',
  //         href: '/content-setting',
  //         icon: <MdSettings />,
  //       },

  //       {
  //         id: 'logout',
  //         title: 'Logout',
  //         action: "logout",
  //         icon: <MdLogout />,
  //       },
  //     ],
  //   },
  // ];


  const shouldShowItem = (item) => {
    if (!item.permissionKey) return true;
    if (role === "admin") return true;
    return permissions[item.permissionKey] == 1;
  };
  const menuItems = [
    {
      items: [
        // {
        //   id: "dashboard",
        //   title: "Dashboard",
        //    permissionKey: "dashboard",
        //   href: "/",
        //   icon: <MdDashboard />,
        // },
        {
          id: "dashboard",
          title: "Dashboard",
          href:
            role?.toLowerCase() === "admin"
              ? "/"
              : permissions?.dashboard == 1
                ? "/"
                : "/staff-dashboard",
          icon: <MdDashboard />,
        },
        {
          id: "staff-management",
          title: "Employees",
          permissionKey: "staff",
          dropdown: true,
          icon: <MdGroups />,
          children: [
            {
              id: "staff",
              title: "Employes",
              href: "/staff-list",
              permissionKey: "staff",
              icon: <MdPeople />,
            },
            {
              id: "role",
              title: "Roles",
              href: "/role-list",
              permissionKey: "role",
              icon: <MdAssignment />,
            },
            {
              id: "department",
              title: "Departments",
              href: "/deparment-list",
              permissionKey: "department",
              icon: <MdCorporateFare />,
            },
            // {
            //   id: "StaffActivity",
            //   title: "Employee Activity",
            //   href: "/Staff-activity",
            //   icon: <MdCheckCircle />,
            //   permissionKey: "StaffActivity",
            // },
          ],
        },
        // {
        //   id: "user-management",
        //   title: "Users",
        //   permissionKey: "user",
        //   dropdown: true,
        //   icon: <MdGroups />,
        //   children: [
        //     {
        //       id: "user-list",
        //       title: "Users",
        //       href: "/user-list",
        //       permissionKey: "user",
        //       icon: <MdPeople />,
        //     },
        //   ],
        // },

        {
          id: "Lead Management",
          title: "Leads",

          permissionKey: "lead",
          dropdown: true,
          icon: <MdBusinessCenter />,
          children: [
            // {
            //   id: "alllead",
            //   title: "Lead List",
            //   href: "/lead-list",
            //   permissionKey: "alllead",
            // },
            // {
            //   id: "newlead",
            //   title: " New",
            //   href: "/new-lead-list",
            //   permissionKey: "newlead",
            // },
            {
              id: "newlead",
              title: "New",
              href:
                role === "admin"
                  ? "/new-lead-list"
                  : "/new-assign-lead-list",
              permissionKey: "newlead",
            },
            {
              id: "pendinglead",
              title: " Pending",
              // href: "/pending-lead-list",
              href:
                role === "admin"
                  ? "/admin-pending-lead-list"
                  : "/staff-pending-lead-list",
              permissionKey: "pendinglead",
            },
            // {
            //   id: "alllead",
            //   title: "Other",
            //   href: "/lead-list",
            //   permissionKey: "alllead",
            // },

            {
              id: "alllead",
              title: "Others",
              href:
                role === "admin"
                  ? "/lead-list"
                  : "/other-lead-list",
              permissionKey: "alllead",
            },

            ...(role === "admin"
              ? [
                {
                  id: "LeadAssigned",
                  title: "Assigned Lead",
                  href: "/lead-staff-list",
                  permissionKey: "LeadAssigned",
                },
                {
                  id: "deletedlead",
                  title: "Deleted",
                  href: "/deleted-lead-list",
                  permissionKey: "deletedlead",
                },
              ]
              : []),
            // {
            //   id: "remark",
            //   title: "Remarks",
            //   href: "/remark-staff-list",
            //   permissionKey: "remark",
            // },
          ],
        },

        {
          id: "inventoryManagement",
          title: "Inventory",
          permissionKey: "inventoryManagement",
          dropdown: true,
          icon: <MdInventory />,
          children: [
            {
              id: "category",
              title: "Categories",
              href: "/categories-list",
              icon: <MdCategory />,
              permissionKey: "category",
            },
            {
              id: "subcategory",
              title: "Sub Categories",
              href: "/sub-categories-list",
              icon: <MdCategory />,
              permissionKey: "subcategory",
            },
            {
              id: "childcategory",
              title: "Child Categories",
              href: "/child-categories-list",
              icon: <MdCategory />,
              permissionKey: "childcategory",
            },
            {
              id: "brand",
              title: "Brand",
              href: "/brand-list",
              icon: <MdBrandingWatermark />,
              permissionKey: "brand",
            },
            {
              id: "unit",
              title: "Unit",
              href: "/unit-list",
              icon: <MdStraighten />,
              permissionKey: "unit",
            },
            {
              id: "color",
              title: "Color",
              href: "/color-list",
              icon: <MdStraighten />,
              permissionKey: "color",
            },
            {
              id: "size",
              title: "Size",
              href: "/size-list",
              icon: <MdStraighten />,
              permissionKey: "size",
            },
            {
              id: "wherehouse",
              title: "WhereHouses",
              href: "/wherehouse-list",
              icon: <MdStraighten />,
              permissionKey: "wherehouse",
            },
            {
              id: "product",
              title: "Products",
              href: "/product-list",
              icon: <MdCategory />,
              permissionKey: "product",
            },
            {
              id: "suppliers",
              title: "Suppliers",
              href: "/supplier-list",
              icon: <MdCategory />,
              permissionKey: "product",
            },
            {
              id: "purchase",
              title: "Purchases",
              href: "/purchase-list",
              icon: <MdCategory />,
              permissionKey: "purchase",
            },
            {
              id: "stocktransfer",
              title: "Stock Transfer",
              href: "/transfer-inventroy-list",
              icon: <MdCategory />,
              permissionKey: "stocktransfer",
            },


            //  {
            //   id: "user-list",
            //   title: "Vendor",
            //   href: "/user-list",
            //   permissionKey: "user",
            //   icon: <MdPeople />,
            // },

          ],
        },
        {
          id: "StaffActivity",
          title: "Activity",
          href: "/activity-list",
          icon: <MdCheckCircle />,
          permissionKey: "StaffActivity",
        },
        {
          id: "user-list",
          title: "Vendor",
          href: "/user-list",
          permissionKey: "user",
          icon: <MdPeople />,
        },
        {
          id: "deleted-vendor-list",
          title: "Deleted Vendor",
          href: "/deleted-vendor-list",
          permissionKey: "deletedVendor",
          icon: <MdPeople />,
        },

        {
          id: "subscription",
          title: "Subscriptions",
          permissionKey: "subscription",
          dropdown: true,
          icon: <MdInventory />,
          children: [
            {
              id: "planlist",
              title: "New Plan",
              href: "/plan-list",
              icon: <MdCategory />,
              permissionKey: "planlist",
            },
            {
              id: "asignvenderplanlist",
              title: "Vendor Subscription",
              href: "/plan-vender-list",
              icon: <MdCategory />,
              permissionKey: "asignvenderplanlist",
            },
          ],
        },
        {
          id: "Demo Ai",
          title: "AI Agent Demo Call",
          href: "/create-demo-call",
          icon: <MdChat />,
          permissionKey: "demo",
        },
        {
          id: "enquiry",
          title: "Enquiries",
          permissionKey: "enquiry",
          dropdown: true,
          icon: <MdInventory />,
          children: [
            {
              id: "Pending",
              title: "Pending",
              href: "/pending-enquries-list",
              icon: <MdCategory />,
              permissionKey: "Pending",
            },
            {
              id: "approved",
              title: "Approved",
              href: "/approved-enquries-list",
              icon: <MdCategory />,
              permissionKey: "approved",
            },
            {
              id: "rejected",
              title: "Rejected",
              href: "/rejected-enquries-list",
              icon: <MdCategory />,
              permissionKey: "rejected",
            },
            {
              id: "deleted",
              title: "Restore",
              href: "/deleted-enquries-list",
              icon: <MdCategory />,
              permissionKey: "deleted",
            },
          ],
        },

        {
          id: "module-list",
          title: "Module List",
          href: "/module-list",
          permissionKey: "module",
          icon: <MdPeople />,
        },

        // {
        //   id: "businessCategoryList",
        //   title: "Business Category List",
        //   href: "/business-category-list",
        //   permissionKey: "businessCategoryList",
        //   icon: <MdPeople />,
        // },
        // {
        //   id: "apiProvider",
        //   title: "Api Provider List",
        //   href: "/api-provider-list",
        //   permissionKey: "apiProvider",
        //   icon: <MdPeople />,
        // },
        // {
        //   id: "cloud&devops",
        //   title: "Cloud & Dev Ops",
        //   href: "/api-provider-list",
        //   permissionKey: "devops",
        //   icon: <MdPeople />,
        // },

        // {
        //   id: "paymentlsit",
        //   title: "Payment List",
        //   href: "/Payment-list",
        //   permissionKey: "paymentlsit",
        //   icon: <MdPeople />,
        // },

        // {
        //   id: "chat",
        //   title: "Chat",
        //   href: "/chat",
        //   icon: <MdChat />,
        //   permissionKey: "chat",
        // },


        //        {
        //   id: "enquiry",
        //   title: "Enquiry List",
        //   href: "/enquries-list",
        //   icon: <MdEvent />,
        //   permissionKey: "enquiry",
        // },
        // {
        //   id: "faq",
        //   title: "FAQ",
        //   href: "/faq",
        //   icon: <MdQuestionAnswer />,
        // },



        {
          id: "reminder",
          title: "Reminder",
          // href: "/reminder",
          href: "/reminder-list",
          icon: <MdNotificationsActive />,
          permissionKey: "reminder",
        },

        // {
        //   id: "meeting",
        //   title: "Meeting",
        //   href: "/meeting-list",
        //   icon: <MdEvent />,
        //   permissionKey: "meeting",
        // },


        // {
        //   id: "leave",
        //   title: "Leave",
        //   href: "/leave",
        //   icon: <MdAssignment />,
        //   permissionKey: "leave",
        // },

        // {
        //   id: "calendar",
        //   title: "Calendar",
        //   href: "/calendar",
        //   icon: <MdCalendarMonth />,
        //   permissionKey: "calendar",
        // },

        {
          id: "setting",
          title: "Setting",
          permissionKey: "setting",
          dropdown: true,
          icon: <MdInventory />,
          children: [
            {
              id: "paymentgatway",
              title: "Payment Gateway Intigration",
              href: "",
              icon: <MdCategory />,
              permissionKey: "paymentgatway",
            },

          ],
        },


        {
          id: "logout",
          title: "Logout",
          action: "logout",
          icon: <MdLogout />,
        },
      ],
    },
  ];

  const handleLogout = async () => {
    try {
      await logoutAdmin();
      // Cookies.remove("adminToken");
      localStorage.removeItem("adminToken");
      localStorage.clear();
      successToast("Logged out successfully");
      navigate("/login");
    } catch (error) {
      console.log(error);
      // Cookies.remove("adminToken");
      localStorage.removeItem("adminToken");
      localStorage.clear();
      navigate("/login");
      errorToast("Logout failed but session cleared");
    }
  };
  useEffect(() => {
    menuItems.forEach((section) => {
      section.items.forEach((item) => {
        if (item.href === location.pathname) {
          setActiveMenu(item.id);
          localStorage.setItem("activeMenu", item.id);
        }
        if (item.children) {
          item.children.forEach((child) => {
            if (child.href === location.pathname) {
              setActiveMenu(child.id);
              setActiveDropdown(item.id);
              localStorage.setItem("activeMenu", child.id);
            }
          });
        }

      });
    });
  }, [location.pathname]);

  const toggleDropdown = (dropdownId) => {
    setActiveDropdown((prev) =>
      prev === dropdownId ? null : dropdownId
    );
  };

  const renderMenuItem = (item) => {

    // 🔥 LOGOUT ITEM
    if (item.action === "logout") {
      return (
        <li key={item.id}
          className={`menu-item ${activeMenu === item.id ? "active" : ""}`}
        >
          <div
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            {item.icon && (
              <span className="menu-icon">{item.icon}</span>
            )}

            <span className="menu-text">{item.title}</span>
          </div>
        </li>
      );
    }

    // 🔥 NORMAL ITEMS
    const isDropdownOpen = activeDropdown === item.id;

    return (
      <li
        key={item.id}
        className={`menu-item ${activeMenu === item.id ? "active" : ""}`}
      >

        {/* DROPDOWN */}
        {item.dropdown ? (
          <a
            href="#"
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown(item.id);
              setActiveMenu(item.id);
            }}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}

            <span className="menu-text">{item.title}</span>

            <span className={`menu-arrow ${isDropdownOpen ? "rotate" : ""}`}>
              <IoIosArrowDown />
            </span>
          </a>
        ) : (
          <Link
            to={item.href}
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={() => setActiveMenu(item.id)}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
          </Link>
        )}

        {/* CHILDREN */}
        {item.dropdown && isDropdownOpen && (
          <div className="collapse show">
            <ul className="sub-menu">
              {/* {item.children.map((child) => (
                <li
                  key={child.id}
                  className={`menu-item ${activeMenu === child.id ? "active" : ""}`}
                >
                  <Link
                    to={child.href}
                    onClick={() => setActiveMenu(child.id)}
                    className={`menu-link ${activeMenu === child.id ? "active" : ""}`}
                  >
                    <span className="menu-text">{child.title}</span>
                  </Link>
                </li>
              ))} */}
              {item.children
                .filter((child) => shouldShowItem(child))
                .map((child) => (
                  <li
                    key={child.id}
                    className={`menu-item ${activeMenu === child.id ? "active" : ""
                      }`}
                  >
                    <Link
                      to={child.href}
                      onClick={() => setActiveMenu(child.id)}
                      className={`menu-link ${activeMenu === child.id ? "active" : ""
                        }`}
                    >
                      <span className="menu-text">{child.title}</span>
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        )}

      </li>
    );
  };

  return (
    <div className={`sidebar position-relative ${!isOpen ? 'closed' : ''}`}>
      {!isOpen && (
        <div
          className="overlaysidebar"
          onClick={onToggleSidebar}
        ></div>
      )}
      {!isOpen && (
        <div
          className="closebutton"
          onClick={onToggleSidebar}
        >
          <IoMdClose />
        </div>
      )}

      <div className={`main-menu ${isOpen ? '' : 'active'}`}>

        <div className="logo-box">

          <Link className="logo-light" to="/">

            <img
              src={logo}
              alt="logo"
              className="logo-lg"
              height="40"
            />
            {/* <h1>CRM Admin</h1> */}
          </Link>

        </div>
        <div className="sidebar-content">

          <ul className="app-menu">

            {/* {menuItems.map((section, index) => (
              <React.Fragment key={index}>

                {section.items.map((item) =>
                  renderMenuItem(item)
                )}

              </React.Fragment>
            ))} */}
            {menuItems.map((section, index) => (
              <React.Fragment key={index}>
                {section.items
                  .filter((item) => shouldShowItem(item))
                  .map((item) => renderMenuItem(item))}
              </React.Fragment>
            ))}
          </ul>

        </div>

      </div>

    </div>
  );
};

export default Sidebar;